import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AveriasService } from 'src/app/servicios/averias.service';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { SnackBarComponent } from '../../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { data } from 'jquery';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
    selector: 'app-edit-usuario',
    templateUrl: './edit-usuario.component.html',
    styleUrls: ['./edit-usuario.component.css'],
    standalone: true,
    imports: [FormsModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class EditUsuarioComponent implements OnInit {

  @Output() cerrar = new EventEmitter<any>();
  @Output() cerrarUpdate = new EventEmitter<any>();
  @ViewChild('MSJConfirmaCancelarEDIT') private templateRefEditUsuario: TemplateRef<any>;
  @Input() public datos: any;
  modalRef: BsModalRef;
  durationInSeconds = 3;
  idCliente: number;
  empresaSelected;
  perfilSelected;
  clienteSelected;
  nombre = "";
  apellido = "";
  email = "";
  nombreDeUsuario = "";
  empresas = [];
  perfiles = [];
  perfilesOperador = [];
  clientes = [{ value: 1, label: "FORD" }]
  optEmpCli = [{ value: true, label: "Empresa" }, { value: false, label: "Cliente" }];
  flagEmpCli = true;
  usuarioAEditar;
  showSpinner: boolean = false;
  cargoPerfiles: boolean = false;
  dtoEdicionUsuario;
  idTipoOperador: number = 0;

  constructor(private svcUsuarios: PerfilesUsuarioService, private svcAverias: AveriasService, private _snackBar: MatSnackBar, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem("idCliente"));
    this.idTipoOperador = Number(localStorage.getItem("idTipoOperador"));
    if (this.datos.empresa == null) { this.llenarPerfiles(); }
    else { this.traerPerfilesOperador(); }
    this.llenarEmpresas();
    this.empresaSelected = this.datos.empresaId;
    this.perfilSelected = this.datos.perfilId;
    this.nombre = this.datos.nombre;
    this.apellido = this.datos.apellido;
    this.email = this.datos.correoElectronico;
    this.clienteSelected = this.datos.clienteId;
    this.nombreDeUsuario = this.datos.username;
  }

  llenarEmpresas() {
    this.svcAverias.getOperadoresPorCliente(this.idCliente).subscribe(data => {
      let misEmpresas;
      this.empresas = [];
      misEmpresas = data;
      misEmpresas.forEach(e => {
        this.empresas.push({
          value: e.id,
          label: e.descripcion
        })
      });
    });
  }

  llenarPerfiles() {
    this.svcUsuarios.getPerfiles().subscribe(data => {
      let misPerfiles;
      this.perfiles = [];
      misPerfiles = data;
      let isAdmin = misPerfiles.content.find(e => e.idTipoOperador === this.idTipoOperador && e.perfilRoles.find(e => e.rol.id === 6))
      misPerfiles.content.forEach(e => {
        if (this.svcUsuarios.GESTIONAR_USUARIOS) {
          if (e.cliente && e.id !== 24) {
            this.perfiles.push({
              value: e.id,
              label: e.descripcion
            })
          }
        } else {
          if (e.operador) {
            //AGREGAMOS UNA LOGICA PARA PUSHEAR LOS PERFILES DEL TIPO DE OPERADOR SI TIENE
            if (e.idTipoOperador == null || e.idTipoOperador == this.idTipoOperador && e.id !== isAdmin.id) {
              this.perfiles.push({
                value: e.id,
                label: e.descripcion
              })
            }
          }
        }
      });
      this.cargoPerfiles = true;
    });
  }

  traerPerfilesOperador() {
    this.svcUsuarios.getPerfiles().subscribe(data => {
      this.perfilesOperador = data.content;
      this.llenarPerfilesOperador();
    });
  }
  llenarPerfilesOperador() {
    this.perfiles = [];
    let isAdmin = this.perfilesOperador.find(e => e.idTipoOperador === this.idTipoOperador && e.perfilRoles.find(e => e.rol.id === 6))
    if (this.empresaSelected != 0) {
      this.perfilesOperador.forEach(e => {
        if (e.operador) {
          //AGREGAMOS UNA LOGICA PARA PUSHEAR LOS PERFILES DEL TIPO DE OPERADOR SI TIENE
          if (e.idTipoOperador == null || e.idTipoOperador == this.idTipoOperador && e.id !== isAdmin.id) {
            this.perfiles.push({
              value: e.id,
              label: e.descripcion
            })
          }
        }
      });
      this.cargoPerfiles = true;
    } else {
      this.llenarPerfiles();
    }
  }

  actualizarNombreUser(ev) {
    let primeraLetra = this.nombre != "" ? this.nombre.slice(0, 1) : "";
    this.nombreDeUsuario = primeraLetra + this.apellido;
  }

  saveEditUsuario() {
    this.showSpinner = true;
    this.svcUsuarios.putPerfilUsuario(this.datos.id, this.dtoEdicionUsuario).subscribe(data => {
      this.openSnackBar("Usuario editado con éxito.");
      this.cerrarModalUpdate();
      this.showSpinner = false;
    });
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  cerrarModal() {
    this.cerrar.emit("cerrar");
  }

  saveChangeUsuario(ev) {
    let valido = false;
    this.dtoEdicionUsuario = {
      username: this.nombreDeUsuario.toLocaleLowerCase(),
      nombre: this.nombre,
      apellido: this.apellido,
      // jalbano dice: Campo dni: el back no utiliza este campo para el update, por eso lo enviamos vacio
      dni: "",
      correoElectronico: this.email,
      idPerfil: this.perfilSelected,
      idOperador: this.datos.operadorId == "" ? 0 : this.datos.operadorId,
      idCliente: this.idCliente
    }
    valido = this.validarDatos(this.dtoEdicionUsuario)
    if (valido) {
      this.modalRef = this.modalService.show(this.templateRefEditUsuario, { class: 'modal-lg' });
    }
  }

  hideConfirm() {
    this.modalRef.hide();
    this.cerrarModal();
  }
  cerrarModalUpdate() {
    this.modalRef.hide();
    this.cerrarUpdate.emit("cerrarUpdate")
  }

  validarDatos(dto) {
    if (dto.nombre.length <= 0) {
      alert("Debe ingresar nombre")
      return false;
    }
    if (dto.apellido.length <= 0) {
      alert("Debe ingresar apellido")
      return false;
    }
    if (dto.correoElectronico.length <= 0) {
      alert("Debe ingresar e-mail")
      return false;
    }
    if (dto.idPerfil == 0) {
      alert("Debe elegir algún perfil")
      return false;
    }
    return true;
  }

}
